// GENERATED FILE — DO NOT EDIT.
// Source of truth: config/compliance-status.json
// Regenerate: node scripts/generate-compliance-status.mjs
//
// Prest0's own SOC 2 and HIPAA status, in the words every page publishes (scripts/lib/compliance-words.mjs).
// scripts/check-compliance-status.mjs refuses a status sentence written anywhere else, so read these instead of
// writing one: the day a status changes, the config is the only edit.

/** The date the status was last checked against the auditor's and the program's own record. */
export const COMPLIANCE_LAST_REVIEWED = "2026-10-16";

/** Each program's name, its status as a reader sees it, whether it is held, and its sentence. */
export const COMPLIANCE = {
  soc2Type1: {
    name: "SOC 2 Type 1",
    status: "audit-underway",
    state: "audit underway",
    held: false,
    sentence: "Prest0’s own SOC 2 Type 1 audit is underway, and the report is expected in Q4 2026. Once the report is issued, we share it under NDA.",
    short: "SOC 2 Type 1 audit underway, report expected Q4 2026",
  },
  soc2Type2: {
    name: "SOC 2 Type 2",
    status: "in-progress",
    state: "in progress",
    held: false,
    sentence: "Prest0’s SOC 2 Type 2, which tests how our controls work over months rather than on one day, is in progress.",
    short: "SOC 2 Type 2 in progress",
  },
  hipaa: {
    name: "HIPAA",
    status: "in-progress",
    state: "in progress",
    held: false,
    sentence: "Prest0’s HIPAA program is in progress. A business associate agreement is not available yet, so talk to us before putting protected health information in Prest0.",
    short: "HIPAA program in progress, no business associate agreement yet",
    program: "Prest0’s HIPAA program is in progress.",
    baa: "A business associate agreement is not available yet, so talk to us before putting protected health information in Prest0.",
  },
  /** Google Cloud's reports for the infrastructure, the same at every status of Prest0's own. */
  infrastructure: "Google Cloud, which runs the infrastructure underneath Prest0, holds SOC 2 Type II and ISO/IEC 27001 for it. Those reports are Google’s, not Prest0’s.",
  /** The two reports and the infrastructure, as one paragraph. */
  paragraph: "Prest0’s own SOC 2 Type 1 audit is underway, and the report is expected in Q4 2026. Once the report is issued, we share it under NDA. Prest0’s SOC 2 Type 2, which tests how our controls work over months rather than on one day, is in progress. Google Cloud, which runs the infrastructure underneath Prest0, holds SOC 2 Type II and ISO/IEC 27001 for it. Those reports are Google’s, not Prest0’s.",
  /** The short form the signed-out Prest0n's page digest carries. */
  digest: "Prest0’s own SOC 2 Type 1 audit underway, report expected Q4 2026; SOC 2 Type 2 in progress. Never call one held before it is issued. HIPAA program in progress, no BAA yet.",
  /** The headline form: "SOC 2 compliant" once a SOC 2 report of Prest0's own is issued, else null (draw nothing). */
  badge: null,
} as const;

/**
 * The same facts as bare prose lines, for the public-site index the signed-out Prest0n searches (D13). Not rendered:
 * the pages render COMPLIANCE above.
 */
export const COMPLIANCE_LINES: readonly string[] = [
  "Prest0’s own SOC 2 Type 1 audit is underway, and the report is expected in Q4 2026. Once the report is issued, we share it under NDA.",
  "Prest0’s SOC 2 Type 2, which tests how our controls work over months rather than on one day, is in progress.",
  "Prest0’s HIPAA program is in progress.",
  "A business associate agreement is not available yet, so talk to us before putting protected health information in Prest0.",
  "Google Cloud, which runs the infrastructure underneath Prest0, holds SOC 2 Type II and ISO/IEC 27001 for it. Those reports are Google’s, not Prest0’s.",
];
